export default ({ href = '/shop/package-deals', className = '' }) => {
    return (
        <a href={href} className={`back-to-school-banner ${className}`.trim()}>
            <span className="back-to-school-banner__title">Package Deals</span>
            <span className="back-to-school-banner__copy">
                <strong>Frames + Lenses</strong> starting at $99
            </span>
            <span className="back-to-school-banner__cta">Shop Now</span>
        </a>
    )
}
